import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Register from './pages/Register';
import Login from './pages/Login';
import Verify from './pages/Verify';
import { AuthProvider } from './contexts/AuthContext';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import AdminDashboard from './pages/AdminDashboard'; 
import FundCryptoPage from './pages/FundCryptoPage';
import FundDepositPage from './pages/FundDepositPage';
import CardPage from './pages/CardPage';
import BankTransferPage from './pages/BankTransferPage';
import SettingsPage from './pages/SettingsPage';
import TransactionsPage from './pages/TransactionsPage';
import CryptoDetailPage from './pages/CryptoDetail';
import SeedPhraseSection from './components/SeedPhraseSection';
import KycPage from './pages/KycPage';

<Toaster 
  position="top-center"
  toastOptions={{
    duration: 3000,
    style: {
      background: '#363636',
      color: '#fff',
    },
  }}
/>

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-white">
          <Navbar />
          <Toaster position="top-right" />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/register" element={<Register />} />
            <Route path="/fund" element={<FundCryptoPage />} />
            <Route path="/fund/:coinId" element={<FundDepositPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/verify/:token" element={<Verify />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/card" element={<CardPage />} />
            <Route path="/bank-transfer" element={<BankTransferPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/transactions" element={<TransactionsPage />} />
            <Route path="/crypto-detail" element={<CryptoDetailPage />} />
            <Route path="/seed-phrase" element={<SeedPhraseSection />} />
            <Route path="/kyc" element={<KycPage />} />
            {/* Fallback for unknown routes (optional, but good for debugging) */}
            <Route path="*" element={<div className="min-h-screen bg-white flex items-center justify-center"><p>404 - Page not found</p></div>} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;